<template>
    <div class="page-loading">
        <i class="fas fa-spinner fa-spin"></i> {{ tt('please_wait') }}
    </div>
</template>
<script>
    export default {
        name: 'page-loading'
    };
</script>